import { render } from "./InterfaceMainMenuItems.vue?vue&type=template&id=5e228a23"
import script from "./InterfaceMainMenuItems.vue?vue&type=script&lang=js"
export * from "./InterfaceMainMenuItems.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__